// Actions
export const REVIEW__REVIEW_SERVICE = 'REVIEW__REVIEW_SERVICE';
export const REVIEW__GET_TIPPING_OPTIONS = 'REVIEW__GET_TIPPING_OPTIONS';
// Mutations
export const REVIEW__RESET = 'REVIEW__RESET';
export const REVIEW__MUTATE_LOADING_STATUS = 'REVIEW__MUTATE_LOADING_STATUS';
export const REVIEW__MUTATE_TIPPING_OPTIONS = 'REVIEW__MUTATE_TIPPING_OPTIONS';
